export const ScanIcon = (props: any) => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="22" viewBox="0 0 24 22" fill="none" {...props}>
      <path d="M2.22217 10.7021H21.7777" stroke="#011BB6" strokeWidth="2.66667" strokeMiterlimit="10" strokeLinecap="square"/>
      <path d="M4.88892 6.99964V4.77832H7.55558" stroke="#011BB6" strokeWidth="2.66667" strokeMiterlimit="10" strokeLinecap="square"/>
      <path d="M16.4443 4.77832H19.111V6.99964" stroke="#011BB6" strokeWidth="2.66667" strokeMiterlimit="10" strokeLinecap="square"/>
      <path d="M19.111 14.4038V16.6251H16.4443" stroke="#011BB6" strokeWidth="2.66667" strokeMiterlimit="10" strokeLinecap="square"/>
      <path d="M7.55558 16.6251H4.88892V14.4038" stroke="#011BB6" strokeWidth="2.66667" strokeMiterlimit="10" strokeLinecap="square"/>
    </svg>
  );
};
